import { render, staticRenderFns } from "./FullWidthShareBtn.vue?vue&type=template&id=4ec1ed0a"
import script from "./FullWidthShareBtn.vue?vue&type=script&lang=js"
export * from "./FullWidthShareBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports